import React from "react";
import { Link } from "react-router-dom";
import "./ContactHeaderHero.css";

export default function ContactHeaderHero() {
  const base = process.env.PUBLIC_URL;

  return (
    <section
      className="ch-hero"
      role="banner"
      aria-label="Contact hero banner"
    >
      {/* Background image */}
      <img
        className="ch-hero__bg"
        src={`${base}/tacoma4.webp`}
        alt="Team member assisting a customer"
        loading="eager"
      />

      {/* Gradient/dimming overlay */}
      <div className="ch-hero__overlay" aria-hidden="true" />

      {/* Centered content */}
      <div className="ch-hero__content">
        <nav className="ch-hero__breadcrumb" aria-label="Breadcrumb">
          <Link to="/" className="ch-hero__breadcrumb-link">Home</Link>
          <span className="ch-hero__breadcrumb-sep" aria-hidden="true">›</span>
          <span className="ch-hero__breadcrumb-current">Contact</span>
        </nav>

        <h1 className="ch-hero__title">Contact Us</h1>
        <p className="ch-hero__subtitle">
          Community-driven junk removal committed to a greener tomorrow.
        </p>
      </div>

      {/* Premium depth touches */}
      <div className="ch-hero__vignette" aria-hidden="true" />
      <div className="ch-hero__grain" aria-hidden="true" />
    </section>
  );
}
